export default __webpack_public_path__ + "static/media/Document-1.700d5be7.svg";